import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMenu, mdiBellOutline, mdiAccountCircle, mdiChevronDown } from "@mdi/js";
import "./header.css";
import axios from "axios";

/** Base API dari ENV, fallback ke localhost */
const API_BASE = process.env.REACT_APP_EXPRESS_API;
const CURRENT_USER_URL = `${API_BASE}/api/users/current`;
const LOGOUT_URL = `${API_BASE}/api/users/logout`;

function Header({ toggleSidebar }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [username, setUsername] = useState("Loading...");
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  // Ambil user saat mount (pakai AbortController biar aman saat unmount)
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const res = await fetch(CURRENT_USER_URL, {
          credentials: "include",
          signal: ac.signal,
        });
        if (!res.ok) throw new Error("Gagal mengambil data user");
        const data = await res.json();
        setUsername(data?.user?.nama || "Pengguna");
      } catch (_) {
        setUsername("Tamu");
      }
    })();
    return () => ac.abort();
  }, []);

  // Klik di luar = tutup menu
  useEffect(() => {
    const closeOnOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutside);
    return () => document.removeEventListener("mousedown", closeOnOutside);
  }, []);

  // ESC untuk nutup menu
  useEffect(() => {
    const onEsc = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  const handleProfile = () => {
    setMenuOpen(false);
    navigate("/akun");
  };

  const handleLogout = async () => {
    try {
      await axios.post(LOGOUT_URL, {}, { withCredentials: true });
    } finally {
      window.location.href = "/";
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        {/* Sesuai catatanmu: klik burger MENUTUP sidebar */}
        <button
          type="button"
          className="menu-icon"
          aria-label="Tutup sidebar"
          onClick={() => toggleSidebar(false)}
        >
          <Icon path={mdiMenu} size={1.2} color="#1e3a8a" />
        </button>
      </div>

      <div className="header-right" ref={menuRef}>
        <button
          type="button"
          className="icon bell"
          aria-label="Notifikasi"
          onClick={() => {/* nanti sambungkan ke panel notif */ }}
        >
          <Icon path={mdiBellOutline} size={1} color="#1e3a8a" />
        </button>

        {/* Tombol profil + dropdown */}
        <button
          type="button"
          className="profile"
          aria-haspopup="menu"
          aria-expanded={menuOpen}
          aria-controls="profile-menu"
          onClick={() => setMenuOpen((s) => !s)}
          ref={buttonRef}
        >
          <Icon path={mdiAccountCircle} size={1} color="#1e3a8a" className="icon user" />
          <span className="username">{username}</span>
          <Icon path={mdiChevronDown} size={0.7} color="#6b7280" className="dropdown-icon" />
        </button>

        {menuOpen && (
          <div
            id="profile-menu"
            className="profile-menu"
            role="menu"
            aria-labelledby="profile-button"
          >
            <button role="menuitem" onClick={handleProfile}>Akun</button>
            <button role="menuitem" onClick={handleLogout}>Keluar</button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
